export const teamFormFromTeam = (team) => ({
    name: team.name || "",
    category: team.category || "U10",
    gender: team.gender || "M",
    description: team.description || "",
    coach_user_id: team.coach_user_id || "",
});

export const teamPayload = (form) => ({
    name: form.name,
    category: form.category,
    gender: form.gender,
    coach_user_id: form.coach_user_id || null,
    description: form.description,
});
